import Component from '../../components/Component';
import Timeline from '../../components/Timeline';
import Loading from '../../components/Loading';

import query from './query';
import keys from './keys';
import { withTranslation } from 'react-i18next';
import { isTrue } from '../../helpers/isTrue';

class Summary extends Component {
    constructor(props) {
        super();
        this.query = query({ page: props.page, domain: props.domain });
    }

    render() {
        const { t } = this.props;
        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <>
                <Timeline
                    data={this.state.data}
                    keys={keys(this.state.isDark, t)}
                    header={t('discover.page.chart.header')}
                    forceRun={this.forceRun}
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    hasRightAxis
                    rightAxisLabel={t('global.ctr_per')}
                    hasLeftSecondAxis
                    leftSecondAxisLabel={t('global.clicks')}
                    leftAxisLabel={t('global.impressions')}
                    customEmptyMessage={
                        this.props.from_gsc ? t('discover.page.chart.error_message') : ''
                    }
                    metricType="primary"
                />
                {!isTrue(this.props.hide_view_button) &&
                    this.state.data &&
                    this.state.data.length && (
                        <div className="redirect-button">
                            <a
                                className="button-close"
                                href={`/domains/${this.props.domain_pk}/pages/page/?page=${this.props.page}`}
                            >
                                {t('discover.page.chart.view_data')}
                            </a>
                        </div>
                    )}
            </>
        );
    }
}

export default withTranslation()(Summary);
